<template>
  <div class="member-tips-container flex items-center" @click="buyMember">
    <img src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="" />
    <div class="member-tips-text"><span>开通会员</span>体验完整面试</div>
  </div>
</template>
<script>
export default {
  name: "MemberTips",
  methods: {
    buyMember() {
      this.$emit("buyMember");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.member-tips-container {
  img {
    width: 26px;
    height: 14px;
    object-fit: contain;
  }
  .member-tips-text {
    font-size: 16px;
    color: $text-color;
    margin-left: 6px;
    font-weight: 600;
    span {
      color: $theme-color;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
